import { action, when } from 'mobx'
import { Document } from 'mobx-document'
import { bewizrAPI } from '~/apis/bewizr'
import { BeWizrLearningTrack } from '~/models'
import bewizrStore from '../bewizrStore'

export default class BeWizrLearningTrackDocument extends Document<BeWizrLearningTrack, string, {}> {

  public async enroll() {
    const api = bewizrAPI()
    if (api == null) { return }

    const endpoint = this.data?.links.enroll
    if (endpoint == null) { return }

    const response = await api.post(endpoint)
    if (response.status === 200 && response.data.learning_track != null) {
      const learningTrack = BeWizrLearningTrack.deserialize({
        ...this.data?.raw ?? {},
        ...response.data.learning_track,
      })
      this.set(learningTrack)
    }
    return response
  }

  public async cancel() {
    const api = bewizrAPI()
    if (api == null) { return }

    const endpoint = this.data?.links.cancel
    if (endpoint == null) { return }

    const response = await api.post(endpoint)
    if (response.status === 200 && response.data.learning_track != null) {
      const learningTrack = BeWizrLearningTrack.deserialize({
        ...this.data?.raw ?? {},
        ...response.data.learning_track,
      })
      this.set(learningTrack)
    }
    return response
  }

  @action
  protected async performFetch() {
    await when(() => bewizrStore.authenticated)

    const api = bewizrAPI()
    if (api == null) { return null }

    const response = await api.get(`learning_track/${this.id}/`)
    if (response.status !== 200) { return response }

    const data = BeWizrLearningTrack.deserialize(response.data)

    return {
      data,
      meta: {},
    }
  }
}